import React from "react"
import { NavLink } from "react-router-dom"
import Header4 from "../Common/Header4"
import Footer from "../Common/Footer"
import Banner from "../Elements/Banner"
import Projects6 from "../Elements/Projects6"
import ReactPlayer from "react-player"

var bnrimg = require("./../../images/projects/portrait/Ivilla/bg.png")

class Ivilla extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script")
        script.src = src
        script.addEventListener("load", function () {
          resolve()
        })
        script.addEventListener("error", function (e) {
          reject(e)
        })
        document.body.appendChild(script)
        document.body.removeChild(script)
      })
    }

    loadScript("./assets/js/custom.js")
  }
  render() {
    return (
      <>
        <Header4 />
        <div className="page-content">
          <Banner
            title="Villa · Mountain View"
            pagename="iVilla Mountain View"
            description="Transforming this iVilla in Mountain View into a modern luxury residence—where contemporary architecture, refined detailing, and carefully curated finishes come together to create an elegant, elevated living experience designed to enhance everyday life."
            bgimage={bnrimg}
          />

          {/* SECTION CONTENT START */}
          <div className="section-full p-tb80 inner-page-padding stick_in_parent">
            <div className="container">
              <div className="row">
                <div className="col-lg-7 col-md-7  sticky_column">
                  <div className="project-detail-containt">
                    <div className="bg-white text-black">
                      <h3>
                        A modern luxury design vision that elevates everyday
                        living
                      </h3>

                      <p>
                        In this iVilla Mountain View residence, design is shaped
                        by clarity, proportion, and refined simplicity.
                        Contemporary architectural lines are complemented by
                        carefully curated materials and subtle detailing,
                        creating interiors that feel elegant, warm, and
                        effortlessly sophisticated. Every element is
                        intentionally designed to enhance comfort, visual
                        balance, and a sense of modern luxury—where form and
                        function coexist seamlessly.
                      </p>

                      <p>
                        The villa unfolds across thoughtfully planned levels,
                        offering spacious bedrooms including a refined master
                        suite, an open kitchen designed for both everyday living
                        and hosting, well-appointed bathrooms, and elegant
                        reception areas connected through fluid circulation.
                        Each space is crafted to ensure privacy, openness, and
                        seamless flow—resulting in a home that reflects
                        individuality, prestige, and contemporary luxury living.
                      </p>

                      <div className="product-block">
                        <ul>
                          <li>
                            <h4 className="m-b10">Status</h4>
                            <p>Completed</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Client</h4>
                            <p>Property Owner</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Project type</h4>
                            <p>Ivilla Mountain View</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Scope of work</h4>
                            <p>Design and build</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Location</h4>
                            <p>Mountain View, New Cairo</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Year</h4>
                            <p>2023</p>
                          </li>
                        </ul>
                      </div>
                      <div className="m-b0">
                        <div className="sx-divider divider-1px  bg-black">
                          <i className="icon-dot c-square" />
                        </div>
                      </div>
                      {/* <ul className="social-icons social-square social-darkest m-b0">
                                            <li><a href="https://www.facebook.com" target="_blank" className="fa fa-facebook" /></li>
                                                <li><a href="https://twitter.com" target="_blank" className="fa fa-twitter" /></li>
                                                <li><a href="https://in.linkedin.com" target="_blank" className="fa fa-linkedin" /></li>
                                                <li><a href="https://rss.com" target="_blank" className="fa fa-rss" /></li>
                                                <li><a href="https://www.youtube.com" target="_blank" className="fa fa-youtube" /></li>
                                                <li><a href="https://www.instagram.com/innen_interiors/" target="_blank" className="fa fa-instagram" /></li>
                                            </ul> */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 col-md-5 ">
                  <div className="project-detail-outer">
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/1.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/2.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/3.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/4.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/5.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/6.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/7.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/8.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/9.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/10.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/11.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/12.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/13.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/14.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/15.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/16.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/17.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Ivilla/18.jpg")}
                          alt=""
                        />
                      </div>
                    </div>

                    {/* <div className="sx-box">
                                            <div className="sx-thum-bx sx-img-overlay1 sx-img-effect yt-thum-box">
                                                <img src="https://img.youtube.com/vi/Oy2QIiSQT2U/0.jpg" alt="" />
                                                <NavLink to={"#"} className="play-now" data-toggle="modal" data-target="#myModal5">
                                                    <i className="icon fa fa-play" />
                                                    <span className="ripple" />
                                                </NavLink>
                                            </div>
                                        </div> */}
                  </div>
                </div>
              </div>
              <div className="project-detail-containt-2 m-t50">
                <h3>
                  Creating a modern luxury home defined by balance, refined
                  detailing, and contemporary comfort
                </h3>

                <p className="m-b0">
                  Modern luxury design is guided by clarity rather than excess.
                  Balanced proportions, clean lines, and carefully curated
                  materials create an atmosphere of understated elegance—where
                  comfort and sophistication meet effortlessly. Through
                  thoughtful planning and refined detailing, the villa is
                  transformed into a distinguished residence that elevates
                  everyday living with calm, precision, and lasting appeal.
                </p>
              </div>
            </div>
          </div>
          {/* SECTION CONTENT END  */}
          {/* <Projects6 /> */}
        </div>

        <div className="modal fade" id="myModal5" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <ReactPlayer url="https://www.youtube.com/watch?v=Oy2QIiSQT2U" />
            </div>
          </div>
        </div>
        <Footer />
      </>
    )
  }
}

export default Ivilla
